import { Dropdown, Input, Tooltip } from "antd";
import React, { useState } from "react";
import { updateSwimlane } from "../../../../Core/redux/api/scheduleAPI";
import { useAppDispatch, useAppSelector } from "../../../../Core/redux/hooks";
import { updateSchedule } from "../../../../Core/redux/slices/schedule.slice";

import { PlusIcon, PlusIconSecondary } from "../../../../Core/svgV2/PlusIcon";
import { DotsVerticalIcon } from "../../../../Core/svgV2/DotsVertical";

import { DeleteIcon } from "../../../../Core/svgV2/DeleteIcon";
import { EditIcon } from "../../../../Core/svgV2/EditIcon";

import EditStatusModal from "../../Modals/EditStatusModal";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import usePermission from "../../../../Core/hooks/usePermission";

const KanbanColumnHeader = ({
  isTask,
  title,
  count,
  channel,
  addSwimalne,
}: {
  isTask: boolean;
  title: string;
  count: string | number;
  channel: any;
  addSwimalne?: () => void;
}) => {
  const [renameStatus, setRenameStatus] = useState(false);
  const { projectId } = useParams();
  const dispatch = useAppDispatch();
  const queryClient: any = useQueryClient();
  const [editStatusModal, setEditStatusModal] = useState(false);
  const { showSubtaskView } = useAppSelector((state) => state.schedule);
  const { hasPermission: TASK_EVENT_SCOPE_ADD } = usePermission("8");

  const items = [
    {
      key: "1",
      label: <div className="out-300-14 text-gray-700">Rename</div>,
      icon: <EditIcon className="text-gray-700" />,
    },

    {
      key: "2",
      label: <div className="out-300-14 text-gray-700  ">Move</div>,
      icon: <img src="/images/v2/schedule/move.svg" />,
    },
    {
      key: "divider",
      type: "divider",
    },
    {
      key: "4",
      label: <div className="out-300-14 text-gray-700  ">Delete</div>,
      icon: <DeleteIcon className="text-gray-700 " />,
    },
  ];

  const onClick = ({ key }) => {
    switch (key) {
      case "1":
        setRenameStatus(true);
        break;
      case "2":
        dispatch(
          updateSchedule({
            key: "moveSwimlaneModal",
            value: true,
          })
        );
        break;

      case "4":
        dispatch(
          updateSchedule({
            key: "deleteStatusModal",
            value: true,
          })
        );
        dispatch(
          updateSchedule({
            key: "swimlaneDetails",
            value: channel,
          })
        );
        break;
      default:
        break;
    }
  };

  const [name, setName] = useState(title);

  const { swimlanes } = useAppSelector((state) => state.schedule);

  const handleRename = async () => {
    let modifiedSwimlanes = [...swimlanes];
    modifiedSwimlanes = modifiedSwimlanes.map((s) => {
      if (s.id === channel.id) {
        return { ...s, title: name };
      }
      return s;
    });

    dispatch(updateSchedule({ key: "swimlanes", value: modifiedSwimlanes }));

    setRenameStatus(false);
    await dispatch(updateSwimlane({ title: name, id: channel.id }));
    queryClient.invalidateQueries(["swimlanes", projectId]);
  };

  return renameStatus ? (
    <Input
      autoFocus
      className="rounded-lg bg-white out-500-14 text-gray-700 uppercase"
      value={name}
      onPressEnter={handleRename}
      onChange={(e) => setName(e.target.value)}
      onBlur={() => setRenameStatus(false)}
    />
  ) : (
    <div className="bg-white group  py-[11px] px-4 pr-2 rounded-lg shadow-xs  hover:shadow-s flex items-center justify-between  max-h-[40px] min-h-[40px]">
      <div className="out-500-12 truncate whitespace-nowrap text-gray-700 flex items-center gap-x-2">
        <p className="uppercase truncate whitespace-nowrap">{title}</p>
        <div className=" rounded-full py-[2px] px-2 bg-primary-50">
          <p className="out-500-12 text-gray-700">{count}</p>
        </div>
      </div>
      <div className="group-hover:flex hidden justfiy-center gap-x-2">
        {!showSubtaskView && TASK_EVENT_SCOPE_ADD && (
          <Tooltip title="Add new task">
            <button
              onClick={() =>
                dispatch(
                  updateSchedule({
                    key: "showNewTaskCard",
                    value: { visible: true, channel },
                  })
                )
              }
            >
              <PlusIconSecondary className="text-gray-700" />
            </button>
          </Tooltip>
        )}
        <Dropdown
          menu={{ items, onClick }}
          dropdownRender={(origin) => <div className="w-[200px]">{origin}</div>}
          trigger={["click"]}
        >
          <button>
            <Tooltip title="More Options">
              <DotsVerticalIcon className="text-gray-700" />
            </Tooltip>
          </button>
        </Dropdown>
      </div>

      <EditStatusModal
        visible={editStatusModal}
        onClose={() => setEditStatusModal(false)}
      />
    </div>
  );
};

export default KanbanColumnHeader;
